import { unsafeDecode, useAuthContext } from '@healthblocks-io/core'
import { useEffect } from 'react'

import { useSessionCredentials } from '@/modules/auth/hooks/useSessionCredentials'

/**
 * Keeps the keychain copy that biometric unlock restores in step with the
 * session. Every refresh issues a new refresh token, and the copy saved at
 * login expires 60 days later, after which biometric unlock would load a dead
 * session.
 */
export const useSyncSessionCredentials = () => {
  const auth = useAuthContext()
  const { saveCredentials } = useSessionCredentials()

  const accessToken = auth.data.current?.access_token
  const refreshToken = auth.data.current?.refresh_token

  useEffect(() => {
    if (!accessToken || !refreshToken) {
      return
    }

    // Biometric unlock is off for a proxy acting for someone else, so a
    // mandate session is never saved. Read from the token itself, because the
    // actor and subject members load later.
    const { actorId, subjectId } = unsafeDecode(refreshToken)
    if (subjectId && subjectId !== actorId) {
      return
    }

    saveCredentials('user', accessToken, refreshToken)
  }, [accessToken, refreshToken, saveCredentials])
}
